import { RoomTypesQuery } from '../../../gql/graphql';
import { RoomDetail } from '../../../hooks/useCreateBooking';

interface RoomGrouping {
  typeId: number;
  typeName: string;
  fullRoomsNeeded: number;
  totalPrice: number;
}

export const groupRoomsAndCalculatePrice = (
  selectedRoomIds: RoomDetail[],
  boatRooms: RoomTypesQuery | undefined,
): RoomGrouping[] => {
  // Group RoomDetails by typeId and calculate totals
  const roomGrouping: Record<number, { count: number; totalPrice: number }> =
    {};

  selectedRoomIds.forEach(({ typeId, numberOfRooms, pricePerRoom }) => {
    if (!roomGrouping[typeId]) {
      roomGrouping[typeId] = { count: 0, totalPrice: 0 };
    }

    roomGrouping[typeId].count += numberOfRooms;
    roomGrouping[typeId].totalPrice += numberOfRooms * pricePerRoom;
  });

  // Map grouped data to RoomGrouping format
  return Object.entries(roomGrouping).map(
    ([typeIdString, { count, totalPrice }]) => {
      const typeId = parseInt(typeIdString, 10);
      const roomType = boatRooms?.roomTypes.find(
        room => room.typeId === typeId,
      );

      if (!roomType) {
        throw new Error(`Room type not found for typeId: ${typeId}`);
      }

      return {
        typeId,
        typeName: roomType.typeName,
        fullRoomsNeeded: count, // Number of rooms of this type needed
        totalPrice, // Total price for all rooms of this type
      };
    },
  );
};
